
import { defineComponent, PropType, computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";

export default defineComponent({
  name: "TextInput",
  components: { Field, ErrorMessage },
  props: {
    input: { type: Object as PropType<any>, required: true },
    values: { type: Object as PropType<Record<string, any>>, required: true },
    modelValue: { type: [String, Number], default: "" },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const visible = computed(() => {
      const cond = props.input.hasDisplayConditions ? props.input.displayCondition(props.values) : true;
      const rel = !props.input.displayRelated || props.values[props.input.displayRelated];
      return cond && rel;
    });

    const model = computed({
      get: () => props.modelValue,
      set: (v) => emit("update:modelValue", v),
    });

    return { visible, model };
  },
});
